import { SpecialOfferProps } from '../types';
import { StyledSpecialOffer, ProductsBackground, StyledFrame } from './style';
import { BundlePrice } from 'components/BundlePrice';
import { EBundlesInternalViewModel } from 'utils/enums';
import { Box } from '@mui/system';
import LocoBingoSaleBadge from 'components/Badge/Sale/LocoBingoSaleBadge';
import { LocoBingoProduct } from './Products/LocoBingoProduct';

export const LocoBingoSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  productsList,
  availability,
  backgroundImage,
  backgroundColor,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  collectText,
  availabilityText,
  timer,
}) => {
  return (
    <StyledFrame onClick={selectOffer}>
      <StyledSpecialOffer
        backgroundImage={backgroundImage}
        backgroundColor={backgroundColor}
        data-testid={dataTestId}
      >
        <div className="frame">
          {salePercentage > 0 && (
            <LocoBingoSaleBadge
              salePercentage={salePercentage}
              salePercentageDisplayType={salePercentageDisplayType}
            />
          )}
          <div className="products__container">
            <ProductsBackground>
              {productsList.map((product, index) => (
                <LocoBingoProduct
                  key={index}
                  index={index}
                  productImage={product.images.product}
                  quantityDisplay={product.quantityDisplay}
                  isMainProduct={
                    !!(salePercentage > 0 && product.strokedSaleQuantity)
                  }
                  textColor={product.textFontColorHex}
                  strokedSaleQuantity={product.strokedSaleQuantity}
                />
              ))}
            </ProductsBackground>
          </div>
          <Box className="price-container">
            <BundlePrice
              prices={prices}
              type={EBundlesInternalViewModel.BAGELCODE}
              availabilityText={`${availabilityText}:`}
              availability={availability}
              isFree={isFree}
              buttonText={collectText}
              timer={timer}
            />
          </Box>
        </div>
      </StyledSpecialOffer>
    </StyledFrame>
  );
};
